import React from 'react';
import Button from '../common/Button';

const AchievementsTab = ({
    achievements,
    addItem,
    editIndex,
    editItem,
    loading,
    onAddChange,
    onEditChange,
    onCancelAdd,
    onCancelEdit,
    onEdit,
    onAddAchievement,
    onUpdateAchievement,
    onDeleteAchievement,
    setAddItem
}) => {
    return (
        <div>
            <div className="flex justify-between items-center mb-3">
                <h3 className="text-lg font-semibold text-gray-900">Achievements</h3>
                {addItem.achievements ? (
                    <div className="flex gap-2">
                        <input
                            type="text"
                            placeholder="Title"
                            value={addItem.achievements.title || ''}
                            onChange={e => onAddChange('achievements', 'title', e.target.value)}
                            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                        />
                        <input
                            type="number"
                            placeholder="Year"
                            value={addItem.achievements.year || ''}
                            onChange={e => onAddChange('achievements', 'year', parseInt(e.target.value))}
                            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                        />
                        <input
                            type="text"
                            placeholder="Description"
                            value={addItem.achievements.description || ''}
                            onChange={e => onAddChange('achievements', 'description', e.target.value)}
                            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                        />
                        <Button
                            type="button"
                            variant="primary"
                            onClick={onAddAchievement}
                            loading={loading}
                        >
                            Add
                        </Button>
                        <Button
                            type="button"
                            variant="secondary"
                            onClick={() => onCancelAdd('achievements')}
                            loading={loading}
                        >
                            Cancel
                        </Button>
                    </div>
                ) : (
                    <Button
                        type="button"
                        variant="primary"
                        onClick={() => setAddItem({ ...addItem, achievements: { title: '', description: '', year: '' } })}
                    >
                        Add Achievement
                    </Button>
                )}
            </div>
            {achievements.length === 0 && <div className="text-gray-500">No achievements added.</div>}
            {achievements.map((ach, idx) => (
                <div key={ach.id || idx} className="border border-gray-200 rounded-lg p-4 mb-3 flex items-center justify-between">
                    {editIndex.achievements === idx ? (
                        <div className="flex gap-2 flex-wrap w-full">
                            <input
                                type="text"
                                placeholder="Title"
                                value={editItem.achievements.title || ''}
                                onChange={e => onEditChange('achievements', 'title', e.target.value)}
                                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                            />
                            <input
                                type="number"
                                placeholder="Year"
                                value={editItem.achievements.year || ''}
                                onChange={e => onEditChange('achievements', 'year', parseInt(e.target.value))}
                                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                            />
                            <input
                                type="text"
                                placeholder="Description"
                                value={editItem.achievements.description || ''}
                                onChange={e => onEditChange('achievements', 'description', e.target.value)}
                                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                            />
                            <Button
                                type="button"
                                variant="primary"
                                onClick={() => onUpdateAchievement(idx)}
                                loading={loading}
                            >
                                Save
                            </Button>
                            <Button
                                type="button"
                                variant="secondary"
                                onClick={() => onCancelEdit('achievements')}
                                loading={loading}
                            >
                                Cancel
                            </Button>
                        </div>
                    ) : (
                        <>
                            <div className="flex-1 flex gap-4 items-center">
                                <span className="font-medium">{ach.title}</span>
                                <span className="text-gray-600">{ach.year}</span>
                                <span className="text-gray-500">{ach.description}</span>
                            </div>
                            <div className="flex gap-2">
                                <Button
                                    type="button"
                                    variant="secondary"
                                    onClick={() => onEdit('achievements', idx)}
                                    loading={loading}
                                >
                                    Edit
                                </Button>
                                <Button
                                    type="button"
                                    variant="danger"
                                    onClick={() => onDeleteAchievement(idx)}
                                    loading={loading}
                                >
                                    Delete
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            ))}
        </div>
    );
};

export default AchievementsTab; 